<template>
  <div
    class="counselor list-view"
    :class="{
      'show-grid-label': showGridLabel,
    }"
  >
    <div class="lav-card__container">
      <div class="lav-card__text">
        <div class="lav-card__text-first">
          <counselor-card-image
            class="list"
            :counselor="counselor"
            :is-list="isArchive"
            :is-therapist="isTherapist"
            :link="advisorLink"
          />
          <span
            class="lav-card__grid-label"
            v-if="showGridLabel"
            v-text="gridLabelText"
          />
          <p class="lav-card__name">
            <a :href="advisorLink" v-text="counselor.name" />
          </p>
          <p class="counselor-card__title" v-text="counselor.title" />
          <div
            class="counselor-card__competence"
            v-if="isTherapist || showCompetenceAreas"
          >
            <competence-area-pills
              v-if="showCompetenceAreas"
              :competence-areas="competenceAreas"
              :filtered-competences="filteredCompetences"
            />
          </div>
          <p
            class="counselor-card__languages"
            v-if="counselor.languages"
            v-html="languagesString"
          />
          <counselor-card-meeting-types
            :counselor="counselor"
            :filtered-meeting-types="filteredMeetingTypes"
            :is-lawyer="isLawyer"
            :is-therapist="isTherapist"
          />
        </div>
        <div class="lav-card__text-second">
          <counselor-archive-card-description
            :counselor="counselor"
            :link="advisorLink"
            :role="role"
          />
          <counselor-archive-card-reviews
            :counselor="counselor"
            :link="advisorLink"
          />
          <counselor-card-availability-slots
            v-if="isTherapist"
            :counselor="counselor"
            :link="advisorLink"
            :role="role"
            :schedule="schedule"
          />
          <counselor-card-cta
            :counselor="counselor"
            :is-therapist="isTherapist"
            :link="advisorLink"
            :show-phone-number="showPhoneNumber"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CompetenceAreaPills from 'Main/components/CompetenceAreaPills.vue';
import CounselorArchiveCardDescription from 'Main/counselor-grid/components/CounselorArchiveCardDescription.vue';
import CounselorArchiveCardReviews from 'Main/counselor-grid/components/CounselorArchiveCardReviews.vue';
import BaseCounselorCard from '../BaseCounselorCard.vue';
import CounselorCardAvailabilitySlots from '../components/availability-slots/CounselorCardAvailabilitySlots.vue';
import CounselorCardImage from '../components/CounselorCardImage.vue';
import CounselorCardMeetingTypes from '../components/CounselorCardMeetingTypes.vue';
import CounselorCardCta from '../components/cta/CounselorCardCta.vue';

export default {

  components: {
    CompetenceAreaPills,
    CounselorArchiveCardDescription,
    CounselorArchiveCardReviews,
    CounselorCardAvailabilitySlots,
    CounselorCardCta,
    CounselorCardImage,
    CounselorCardMeetingTypes,
  },

  computed: {
    advisorLink() {
      if (this.link === '#' || !this.presetCompetence) {
        return this.link;
      }

      const urlParams = new URLSearchParams();
      urlParams.append('caseType', this.presetCompetence);

      return this.link.includes('?')
        ? `${this.link}&${urlParams.toString()}`
        : `${this.link}?${urlParams.toString()}`;
    },

    gridLabelText() {
      if (this.isTherapist && this.counselor.returning_customer) {
        return this.counselor.returning_customer;
      }

      return this.counselor.booked_in_the_latest_72_hours;
    },

    showGridLabel() {
      return this.gridLabelText && (this.isLawyer || this.isTherapist);
    },

    titleText() {
      if (
        !this.counselor.employed_since ||
        isNaN(new Date(this.counselor.employed_since).getFullYear())
      ) {
        return this.counselor.title;
      }

      const employedDate = new Date(this.counselor.employed_since);
      return `${this.counselor.title} ${this.texts.since} ${employedDate.getFullYear()}`;
    },
  },

  data() {
    return {
      currentSite: theme_vars.currentSite,
      currentSiteId: theme_vars.currentSiteId,
      texts: theme_vars.counselorSlider,
    };
  },

  extends: BaseCounselorCard,
  name: 'CounselorCardList',

  props: {
    counselor: {
      required: true,
      type: Object,
    },
    isArchive: {
      default: false,
      type: Boolean,
    },
    isLawyer: {
      default: false,
      type: Boolean,
    },
    isList: {
      default: false,
      type: Boolean,
    },
    isTherapist: {
      default: false,
      type: Boolean,
    },
    role: {
      default: '',
      type: String,
    },
    schedule: {
      required: true,
      type: Array,
    },
    showCompetenceAreas: {
      default: false,
      type: Boolean,
    },
    showPhoneNumber: {
      default: false,
      type: Boolean,
    },
  },
};
</script>
